import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ChavesAcessoService {

  readonly serviceApi = environment.apiUrl;

  constructor(private readonly http: HttpClient) { }

  atualizarChaves(consumerKey: string, consumerSecret: string): Observable<any> {
    const body = {
      ConsumerKey: consumerKey,
      ConsumerSecret: consumerSecret
    };
    return this.http.post(`${this.serviceApi}/v1/sistemas-externos/atualiza-chaves`, body);
  }

}

